<template>
  <div
    class="wrapper"
    v-bind:class="[{ collapsedmenu : toggleSidebar }, { collapseaside : toggleAsidebar }]"
    v-if="oidcUser"
  >
    <header-bar />
    <side-bar />
    <div class="content-wrapper">
      <slot />
    </div>
    <aside-bar />
  </div>
</template>

<script>
import sidebar from "./Sidebar";
import headerbar from "./HeaderBar";
import asidebar from "./Aside";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("oidcStore");
export default {
  name: "DefaultLayout",
  components: {
    "side-bar": sidebar,
    "header-bar": headerbar,
    "aside-bar": asidebar
  },
  data: function() {
    return {
      toggleSidebar: false,
      toggleAsidebar: false
    };
  },
  mounted() {
    this.$root.$on("flyoutSidebar", () => {
      this.toggleSidebar = !this.toggleSidebar;
    });
    this.$root.$on("flyoutAsidebar", () => {
      this.toggleAsidebar = !this.toggleAsidebar;
    });
  },
  computed: {
    ...mapGetters(["oidcUser"])
  }
};
</script>
